import { JsonMapper } from '../modules/mapper/json.mapper';
import { TransferHttp } from '../modules/transfer-http/transfer-http';
import { UtilHelper } from '../helpers/util.helper';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BaseService } from './base.service';
import { PaginationModel, GenreModel, ResponseModel } from '../models';
import { REST_API } from '../modules/constants';

@Injectable()
export class GenreService extends BaseService {

    constructor(public http: TransferHttp) {
        super(http);
    }

    /**
     * Get list variable
     * @returns {Promise<T>|Promise<U>}
     */
    public findAll(paging: boolean = true, filter: any = {}): Promise<PaginationModel> {

        if (!paging) {
            filter.offset = '';
            filter.limit = '';
        }
        const queryString = UtilHelper.parseFilterToString(filter);
        return this.makeHttpGet(`${this.apiUrl}/` + REST_API.GENRE + '?' + queryString)
            .then((res) => {
                res.data = JsonMapper.deserialize(GenreModel, res.data);
                return res;
            });
    }

      /**
     * Get detail
     * @param id
     */
    public findById(id: string): Promise<GenreModel> {
        return this.makeHttpGet(`${this.apiUrl}/${REST_API.GENRE}/${id}`)
            .then((res) => {
                return JsonMapper.deserialize(GenreModel, res);
            });
    }

    /**
     * Create
     * @param data
     */
    public create(data: GenreModel): Promise<ResponseModel> {
        return this.makeHttpPost(`${this.apiUrl}/${REST_API.GENRE}`, JsonMapper.serialize(data));
    }
    /**
     * Update
     * @param data
     */

    public update(data: GenreModel): Promise<ResponseModel> {
        return this.makeHttpPut(`${this.apiUrl}/${REST_API.GENRE}/${data.id}`, JsonMapper.serialize(data));
    }

    public delete(id: string): Promise<ResponseModel> {
        return this.makeHttpDelete(`${this.apiUrl}/${REST_API.GENRE}/${id}`);
    }
}